import { useGallery } from '../../../../provider/GalleryProvider';
import GeneralError from '../../../error/GeneralError';
import type { ReactElement } from 'react';
import GroupPreview from '../group/GroupPreview';

const GroupsOverview = (): ReactElement => {
  const { error, gallery } = useGallery();
  const groups = gallery?.groups || [];
  if (error) {
    return <GeneralError error={error} />;
  }
  return (
    <>
      {groups.map(({ id, name, photos }) => (
        <GroupPreview key={id} id={id} name={name} photos={photos} />
      ))}
    </>
  );
};

export default GroupsOverview;
